import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Input, Button, Picker } from '../root/components/common'
import { Fade } from '@material-ui/core'
import * as actions from '../root/actions'
import { LOCALE_DISPLAY_OPTIONS } from '../root/constants'

const useStyles = makeStyles(theme => ({
    wrapper: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.background,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative'
    },
    formWrapper: {
        width: 600,
        '@media (max-width: 767px)': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '90%'
        },
        '@media (max-width: 320px)': {
            width: '100%'
        }
    },
    loginLogo: {
        backgroundImage: `url("${theme.loginLogo}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        width: 600,
        height: 200,
        marginBottom: 15,
        '@media (max-width: 767px)': {
            width: '90%'
        },
        '@media (max-width: 320px)': {
            width: '100%'
        }
    },
    input: {
        marginBottom: 15
    },
    actionWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 15
    },
    link: {
        fontWeight: 'bold',
        color: theme.primary,
        cursor: 'pointer'
    },
    langPickerWrapper: {
        position: 'absolute',
        top: 20,
        right: 20
    }
}))

function ForgotPassword(props) {
    const classes = useStyles()
    const dispatch = useDispatch()

    const { locale, localeCode } = useSelector(state => state.main)

    const [email, setEmail] = useState('')
    const [isResetActionActive, setIsResetButtonActive] = useState(true)

    const backToLogin = () => {
        props.history.push('/login')
    }

    const requestResetPassword = email => {
        if (!isResetActionActive) return
        dispatch(actions.forgotPasswordRequest(email))
        setIsResetButtonActive(false)
    }

    const onLanguageSelect = localeCode => {
        dispatch(actions.setLocale(localeCode))
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes.langPickerWrapper}>
                <Picker
                    onChange={onLanguageSelect}
                    value={localeCode}
                    options={LOCALE_DISPLAY_OPTIONS}
                />
            </div>
            <Fade in={true} timeout={500}>
                <div className={classes.formWrapper}>
                    <div className={classes.loginLogo}></div>
                    <Input
                        autoFocus
                        className={classes.input}
                        label={locale.common.email}
                        type="email"
                        setValue={setEmail}
                        onEnter={requestResetPassword.bind(this, email)}
                        value={email}
                        disabled={!isResetActionActive}
                    />
                    {isResetActionActive && (
                        <div className={classes.actionWrapper}>
                            <Button
                                onClick={requestResetPassword.bind(this, email)}
                            >
                                {locale.resetPassword.resetPassword}
                            </Button>
                        </div>
                    )}
                    <div className={classes.actionWrapper}>
                        <div onClick={backToLogin} className={classes.link}>
                            {locale.resetPassword.backToLogin}
                        </div>
                    </div>
                </div>
            </Fade>
        </div>
    )
}

export default withRouter(ForgotPassword)
